import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { INSTAGRAM_URL } from "@/lib/api";

export const SiteFooter = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 bg-ink">
      <div className="mx-auto grid max-w-7xl gap-8 px-5 py-12 md:grid-cols-[1.4fr_1fr_1fr] lg:px-8">
        <div className="flex items-start gap-4">
          <img src="/brand/logo-sm.png" alt="" className="h-20 w-auto" />
          <div>
            <p className="font-display text-xl">MC Illusions Prints</p>
            <p className="mt-2 max-w-xs text-sm text-slate-400">{t("footer.tag")}</p>
            <p className="mt-1 text-sm text-slate-500">{t("footer.made")}</p>
          </div>
        </div>
        <div className="flex flex-col gap-2 text-sm font-semibold text-slate-300">
          <Link to="/order" className="hover:text-gold" data-testid="footer-order">{t("nav.order")}</Link>
          <Link to="/#pricing" className="hover:text-gold" data-testid="footer-pricing">{t("nav.pricing")}</Link>
          <Link to="/track" className="hover:text-gold" data-testid="footer-track">{t("nav.track")}</Link>
        </div>
        <div className="flex flex-col gap-2 text-sm font-semibold text-slate-300">
          <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-gold" data-testid="footer-instagram">
            <Instagram className="h-4 w-4" /> @mcillusionsprints
          </a>
          <a href="mailto:mcillusionsprints@gmail.com" className="hover:text-gold" data-testid="footer-email">mcillusionsprints@gmail.com</a>
          <Link to="/admin" className="text-slate-600 hover:text-slate-400" data-testid="footer-admin">{t("nav.admin")}</Link>
        </div>
      </div>
      <p className="border-t border-white/5 py-5 text-center text-xs text-slate-600">© {new Date().getFullYear()} MC Illusions Prints. {t("footer.rights")}</p>
    </footer>
  );
};
